import React from 'react';
import PropTypes from 'prop-types';
import style from './permitDetail.module.scss';
import { renderInfoForType } from '../../../utils/helpers';
import AttachmentDetail from '../../../components/customFields/AttachmentDetail';

const PermitFieldDetails = ({ data, fields, order, schema }) => {
  const hasConditionalValue = (field) => {
    const conditionalKey = field?.conditional_field?.key;
    const conditionalValue = data[conditionalKey];

    if (typeof conditionalValue === 'string') {
      return field?.conditional_values.some(value => conditionalValue === value.value);
    }
    if (Array.isArray(conditionalValue)) {
      return field?.conditional_values.some(value => conditionalValue.includes(value.value));
    }
    if (typeof conditionalValue === 'boolean') {
      return field?.conditional_values.some(value => conditionalValue.toString() === value?.value);
    }
    return false;
  };

  const renderFieldContent = (field) => {
    const fieldValue = data?.[field?.id];
    const boolCheck = fieldValue ? 'Yes' : 'No';
    if (!fieldValue) {
      return field.type === 'boolean' ? boolCheck : '';
    }
    if (field.id === 'lic_exp_date') {
      return `${renderInfoForType(field, fieldValue)} 11:59 PM`;
    }
    if (field.type !== 'select') {
      return renderInfoForType(field, fieldValue, schema, true);
    }
    return fieldValue;
  };

  const renderField = (field) => {
    let newLevelsObject = field?.levels || {};
    if (Object.keys(field?.levels || {})?.length === 0) {
      newLevelsObject = {
        level_1: { title: 'Level 1' },
        level_2: { title: 'Level 2' },
        level_3: { title: 'Level 3' }
      };
    }
    return (
    <>
      {field.type !== 'header' && field.type !== 'signature' && field.type !== 'attachments' && field.type !== 'dataSourceMultiLevel' && (
        <div className={style.halfWidth}>
          <div key={field.id} className={style.eachField}>
            <span className={style.fieldTitle}>{field.title}</span>
            <span className={style.fieldAnswer}>{renderFieldContent(field)}</span>
          </div>
        </div>
      )}

      {field.type === 'dataSourceMultiLevel' && field.dataSourceID === 'ds8'
        && newLevelsObject && Object.keys(newLevelsObject).map(level => (
        data?.response?.[field.id]?.[level]
        &&<div key={`${field.id}-${level}`} className={style.halfWidth}>
            <div className={style.eachField}>
              <span className={style.fieldTitle}>{newLevelsObject[level]?.title}</span>
              <span className={style.fieldAnswer}>{data?.response?.[field.id]?.[level]}</span>
            </div>
          </div>
      ))}

      {['attachments', 'signature'].includes(field.type) && data[field?.id]?.length > 0 && (
        <div className={style.fullWidth}>
          <AttachmentDetail attachments={data[field?.id]} title={field?.title} adp />
        </div>
      )}
    </>
  );
};

  return (
    <>
      {fields.map(field => (
        (order === field?.id || !order)
         && (!field?.conditional || (field?.conditional && hasConditionalValue(field)))
         && (renderField(field))
      ))}
    </>
  );
};

PermitFieldDetails.propTypes = {
  data: PropTypes.shape({}),
  fields: PropTypes.shape([]),
  order: PropTypes.string,
  schema: PropTypes.shape({})
};

PermitFieldDetails.defaultProps = {
  data: {},
  fields: [],
  order: null,
  schema: {}
};

export default PermitFieldDetails;
